"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button = __importStar(require("./A_Button"));
var sizing_1 = require("./sizing");
/** A Title and a Close Button, designed to fit in a Drawer with a responsive width.
 * Can also take an optional secondary button */
var Component = function (p) { return (Preact.h(Box_1.default, { paddingX: "23px", paddingY: "16px" },
    Preact.h(Box_1.default, { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", sx: { backgroundColor: 'background.paper' } },
        p.title ? (Preact.h(Typography_1.default, { variant: "h3", color: "black", "data-testid": 'drawer-title' }, p.title)) : null,
        Preact.h(IconButton_1.default, { color: "inherit", size: "small", onClick: p.onCloseClick },
            Preact.h(Close_1.default, { fontSize: "medium" }))),
    p.buttonText ? (Preact.h(Button.Component, { onClick: p.buttonOnClick, variant: "text", size: "medium", disabled: p.buttonDisabled, sx: { paddingTop: (0, sizing_1.toPixels)(2), width: 'fit-content', paddingX: 0 } }, p.buttonText)) : null)); };
exports.Component = Component;
